module.exports = __webpack_public_path__ + "img/tooltip_caldera-3.a987dccf.jpg";